import { contactData } from '@/mocks/homeData';

export default function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
          {contactData.title}
        </h2>
        <p className="text-foreground-500 text-sm mb-2">{contactData.subtitle}</p>
        <p className="text-foreground-600 text-sm leading-relaxed max-w-xl mx-auto mb-10">
          {contactData.description}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
          {contactData.channels.map((ch) => (
            <div
              key={ch.name}
              className="bg-background-50 rounded-2xl p-5 border border-background-200/60 text-center"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                <i className={`${ch.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="text-foreground-800 font-bold text-sm mb-1 whitespace-nowrap">{ch.name}</h3>
              <p className="text-foreground-400 text-xs leading-relaxed">{ch.desc}</p>
            </div>
          ))}
        </div>

        <div className="max-w-lg mx-auto bg-background-50 rounded-2xl p-6 border border-background-200/60 text-left">
          <h3 className="text-foreground-800 font-bold text-sm mb-4 text-center">发送消息</h3>
          <form
            className="flex flex-col gap-3"
            data-readdy-form=""
            action="https://readdy.ai/api/form/d9lfq6e8mbnljin59cj0"
            method="POST"
          >
            <input
              type="text"
              name="name"
              placeholder="你的昵称"
              className="w-full px-4 py-3 rounded-xl bg-background-100 border border-background-200/60 text-foreground-700 text-sm placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors"
            />
            <input
              type="email"
              name="email"
              placeholder="你的邮箱"
              className="w-full px-4 py-3 rounded-xl bg-background-100 border border-background-200/60 text-foreground-700 text-sm placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors"
            />
            <textarea
              name="message"
              rows={4}
              maxLength={500}
              placeholder="说说你想爆的料..."
              className="w-full px-4 py-3 rounded-xl bg-background-100 border border-background-200/60 text-foreground-700 text-sm placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors resize-none"
            ></textarea>
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden={true}
              readOnly={true}
              className="honeypot-field"
            />
            <button
              type="submit"
              className="w-full py-3 rounded-xl bg-primary-500 hover:bg-primary-600 text-background-50 font-bold text-sm whitespace-nowrap cursor-pointer transition-colors duration-200"
            >
              发送消息
            </button>
          </form>
        </div>

        <div className="mt-6 text-foreground-400 text-xs">
          或直接发送邮件至{' '}
          <span className="text-primary-500 font-medium">{contactData.email}</span>
        </div>
      </div>
    </section>
  );
}